import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { ItemFilterSearch } from '../filter';
import { Item } from '../item';

@Injectable({
    providedIn: 'root'
})
export class TypeaheadItemHttpService {
    private pathApi: string;

    constructor(private configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/item`
    }

    /** Pesquisa todos os itens cadastrados para o typeahead */
    search(filter: ItemFilterSearch, limit: number): Observable<Item[]> {
       // Params
       let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);

        return this.customHttp.get<Item[]>(this.pathApi, {params});
    }
}
